import { PermissionsStateModel } from "./permissions.state";
import { createSelector } from "@ngrx/store";
import { ShelterAppStateModel } from "../../ShelterAppStateModel";


export const selectFeaturePermissions = (state: ShelterAppStateModel) => state.permissions;

export const selectPermissions = createSelector(
  selectFeaturePermissions,
  (state: PermissionsStateModel) => state.permissions
);

export const selectHasPermission = (permission: string) => createSelector(
  selectPermissions,
  (permissions: string[]) => permissions.includes(permission)
);

export const selectHasAnyPermission = (requiredPermissions: string[]) => createSelector(
  selectPermissions,
  (permissions: string[]) => requiredPermissions.some(p => permissions.includes(p))
);

export const selectAllowedSpecies = createSelector(
  selectFeaturePermissions, (state: PermissionsStateModel) => state.species);

export const selectAllowedLocations = createSelector(
  selectFeaturePermissions, (state: PermissionsStateModel) => state.locations);
